module.exports = __webpack_public_path__ + "fonts/fontawesome/fa-sharp-duotone-regular-400.woff2";